import {DependencyInjectId} from '@@/package/const/DependencyInjectId';
import {type ApplicationContextInterface} from '@@/package/application/applicationContext';
import SurveyApi from "~~/package/apis/survey/SurveyApi";
import {type SurveyResponseModel} from "~~/package/mapper/survey/model/SurveyResponseModel";
import {type SurveyCompletionModel} from "~~/package/mapper/survey/model/SurveyCompletionModel";
import type CustomResponse from "~~/package/types/ResponseType";

export default class SurveyMapper {
    protected surveyApi: SurveyApi;

    constructor(context: ApplicationContextInterface) {
        this.surveyApi = context.getService<SurveyApi>(DependencyInjectId.SurveyApi);
    }

    public async submitResponse(request: SurveyResponseModel): Promise<boolean> {
        const response: CustomResponse<boolean> = (await this.surveyApi.submitSurveyResponse(request)).data;
        return response.data;
    }

    public async fetchCompletions(): Promise<SurveyCompletionModel[]> {
        const response: CustomResponse<SurveyCompletionModel[]> = (await this.surveyApi.getSurveyCompletions()).data;
        return response.data ?? [];
    }
}
